import { VoucherFormSection } from '../../Section';
import { BlackoutFrom } from '../BlackoutFrom';
import { BlackoutTo } from '../BlackoutTo';

const VoucherFormBlackoutPeriod = () => {
  return (
    <VoucherFormSection
      title='Blackout periods'
      subtitle="When the trip can't happen"
      inputs={
        <>
          <BlackoutFrom />
          <BlackoutTo />
        </>
      }
    />
  );
};

export default VoucherFormBlackoutPeriod;
